import {EventEmitter, Injectable} from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {environment} from '../../../../../environments/environment';


export interface Tva {
  id?: number;
  client_id: number;
  station_id: number;
  valeur: number;
  type: '+' | '-';
  restriction: 'Pourcentage' ;
  statut: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class TvaService {
    messageEmitter = new EventEmitter<any>();
    private apiUrl = `${environment.parameters_url}api/settings/tva`;
     constructor(private http: HttpClient) {}

  getTvaList(stationId: number): Observable<{ success: boolean; tvaListe: Tva[] }> {
    return this.http.get<{ success: boolean; tvaListe: Tva[] }>(`${this.apiUrl}/${stationId}`);
  }

  getTvaByValeur(stationId: number, valeur: number): Observable<any> {
    const params = new HttpParams().set('valeur', String(valeur));
    return this.http.get<any>(`${this.apiUrl}/${stationId}/by-valeur`, { params });
  }

  createTva(tva: Tva, stationId: number): Observable<{ success: boolean; tva: Tva }> {
    return this.http.post<{ success: boolean; tva: Tva }>(`${this.apiUrl}/${stationId}`, tva);
  }

  updateTva(tva: Tva, stationId: number): Observable<{ success: boolean; tva: Tva }> {
    return this.http.put<{ success: boolean; tva: Tva }>(`${this.apiUrl}/${stationId}/${tva.id}`, tva);
  }
    sendMessage(message: any) {
        this.messageEmitter.emit(message);
    }
}
